import script from "./PopupReviewMobileMediaSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupReviewMobileMediaSlider.vue?vue&type=script&setup=true&lang=ts"

import "./PopupReviewMobileMediaSlider.vue?vue&type=style&index=0&id=84fd4828&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84fd4828"]])

export default __exports__